import Sidebar from "../../components/sidebar/Sidebar";
import React from "react";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net"; // Import DataTables
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import CalendarDatatable from "./components/CalendarDatatable";

const Calendar = () => {
  return (
    <>
      <div>
        <Sidebar />
      </div>

      <MainSection>
        <SectionHeader title="Calendar" />
        {/* <SearchBar
          titleOne="Add Event"
          addClientPath="/calendar/add-event"
          showEditButton={false}
        /> */}

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <CalendarDatatable />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default Calendar;
